import React from "react";
import TelegramAccountsListPage from "../../screens/TelegramAccountsListPage/TelegramAccountsListPage.component";

const TelegramAccounts: React.FC = () => {
  return <TelegramAccountsListPage />
}

export default TelegramAccounts;